globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modules = appCustomerSpace.Modules || {};

appCustomerSpace.Modules.TasksProjects = (function() {

  TasksProjects.initTasksProjects = function(){
    $('.tasks-project').each(function(){
      new appCustomerSpace.Modules.TasksProjects($(this));
    });
  }

  function TasksProjects($html) {
    this.$html = $html;

    this.init();
  }

  TasksProjects.prototype = {
    init: function() {
      this.initEvents();
    },
    initEvents: function(){
      var _this = this;

      _this.$html.on('click', '.task.checkable', function(e){
        if($(e.target).hasClass('open-modal') || $(e.target).closest('.open-modal').length) return;

        e.stopPropagation();

        $('body').addClass('loading');

        var $task = $(this),
            $form = $task.find('form'),
            $checkbox = $form.find('input[type=checkbox]'),
            checked = $checkbox.prop('checked');

        $checkbox.prop('checked', !checked);

        $.ajax({
          url: $form.attr('action'),
          method: $form.attr('method'),
          data: $form.serialize(),
          success: function(data) {
            if(data.response) {
              var $updated_task = $(data.html.thumb_line),
                  progress = data.data.progress_percentage,
                  progress_color = data.data.progress_color;

              _this.$html.find('.progress-bar').css('width', progress + '%');
              _this.$html.find('.progress-bar').removeClass('progress-bar-success progress-bar-warning progress-bar-danger');
              _this.$html.find('.progress-bar').addClass(`progress-bar-${progress_color}`);
              _this.$html.find('.progress-integer').html(progress);

              $('.online-jump-label').text(progress + '%');
              $('.online-jump-label').removeClass('label-success label-warning label-danger').addClass(`label-${progress_color}`);

              $updated_task.find('[data-popup="tooltip"]').tooltip();
              $task.replaceWith($updated_task);
              $('body').removeClass('loading');
            }
          },
          error: function(data) {}
        })
      });
    }
  }

  return TasksProjects;
})();
